import { HealthConnectionsContainer } from '@screens/HealthConnections/HealthConnectionsContainer';
import { useGetMyHealthConnectionList } from '@viome/viome-base/src/usecase/Health/HealthQuery';

export const HealthConnectionsPage = () => {
  const { data: healthConnectionListData, isLoading } = useGetMyHealthConnectionList();
  const { connections = [], description = '', title = '' } = healthConnectionListData || {};

  return (
    <div className="dark bg-black h-full w-full">
      <HealthConnectionsContainer
        connections={connections}
        title={title}
        description={description}
        isLoading={isLoading}
      />
    </div>
  );
};
